import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import search from '../../img/search.svg';
import cart from '../../img/cart.svg';
import before from '../../img/before.svg';
import Big3Common from "../../js/Big3Common";
/* 개발담당:양유빈
 * 화면기능:서브 헤더 공통, 
*  아이콘: 이전으로버튼, 타이틀, 검색버튼,장바구니 버튼
 * Property: 
 *      링크방식: LinkUrl, ComponentUrl, HistoryBack, LinkUrl, ComponentUrl, HistoryBack중 하나만 사용 가능
 *      LinkUrl: 링크주소 라우팅, LinkUrl="/Home"
 *      ComponentUrl: 컴포넌트 라우팅,  ComponentUrl="ComponentName" 
 *      HistoryBack: HistoryBack=true
 *      HeaderTitle: 헤더 이름,  HeaderTitle="명칭"
 *      IConClassName: 오른쪽에 보여지는 추가기능 아이콘 IConClassName="delete" or hide or write
 *      ContentState: 자식 페이지에서 부모페이지로 저환 할때 부모페이지 값의 설정이 필요한 경우 할당.
 *      ComponentName: Big3Common.Authentication에서 세션 체크위한 속성
*/
export class HeaderSub2 extends Component {
    static displayName = HeaderSub2.name;
        
    constructor(props) {
        super(props);
        this.state = {
            BasketCount:0
        };
        Big3Common.Authentication(this); 
    }   
    async componentDidMount() {
        try {
            let data = await Big3Common.Get("api/Common/Common/GetAllmMgtBasketCount");
            if (data.codeName === Big3Common.ResultCode.Success) {
                let Data = JSON.parse(data.multiDataTable);
                this.setState({ BasketCount: parseInt(Data.Basket) });
            }
        }
        catch (e) {
            console.log("componentDidMount: ", e)
        }
    }  
    PageLink() {

        if (this.props.LinkUrl !== undefined) {
            return (
                <Link to={this.props.LinkUrl} >
                    <img src={before} alt="이전화면" />
                </Link>
            )
        }
        else if (this.props.HistoryBack !== undefined && this.props.HistoryBack === true) {
            return (
                <div className="before pointer">
                    <Link to={-1} >
                        <img src={before} alt="이전화면" />
                    </Link>
                </div>
            )
        }
        else {
            if (this.props.ComponentUrl !== undefined && this.props.ContentState === undefined) {
                return (
                    <div onClick={() => this.props.RenderComponent(this.props.ComponentUrl)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                    </div>
                );
            }
            else if (this.props.ComponentUrl !== undefined && this.props.ContentState !== undefined) {
                //이전 부모 화면에서 전체 state값을 가져오고 다시 돌려 줌. 상태유지가 필요할때
                return (
                    <div onClick={() => this.props.RenderComponent(this.props.ComponentUrl, this.props.ContentState)} style={{ cursor: 'pointer' }}>
                        <img src={before} alt="이전화면" />
                    </div>
                );
            }

        }
    }
    PageAddFunc() {
    }
    render() {
        return (
            <header>
                <div className="nav">
                    {this.PageLink()}
                    <div className="page_title page_title2">
                        {this.props.HeaderTitle}
                    </div>
                    <div className="header_icon_box2">
                        <div className="main_alarm">
                            {this.props.RenderComponent === undefined ? 
                                <Link to="/Search/Goods/Index">
                                    <img src={search} alt="검색아이콘" />
                                </Link>
                                :
                                <img src={search} alt="검색아이콘"
                                    onClick={() => { this.props.RenderComponent('SearchHome'); }}
                                />            
                            }
                        </div>
                        <div className="main_alarm">
                            <Link to="/MyPage/Basket/Index">
                                <img src={cart} alt="카트아이콘" />
                                <span><b>{this.state.BasketCount}</b></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
 